var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8515 35.7606C15.9354 35.5421 22.5397 35.5421 23.6235 35.7606C24.5501 35.9646 25.5521 36.4411 25.5521 37.4815C25.4982 38.4721 24.8884 39.3502 24.0459 39.9079C22.9534 40.7195 21.6713 41.2335 20.3311 41.4187C19.5898 41.5102 18.8615 41.5123 18.1461 41.4187C16.8037 41.2335 15.5216 40.7195 14.4313 39.9058C13.5867 39.3502 12.9769 38.4721 12.923 37.4815C12.923 36.4411 13.925 35.9646 14.8515 35.7606ZM19.3655 0.165527C23.8754 0.165527 28.4823 2.20484 31.2189 5.58842C32.9944 7.76715 33.8089 9.9438 33.8089 13.3274V14.2076C33.8089 16.8025 34.5286 18.332 36.1123 20.0946C37.3125 21.3931 37.6961 23.0599 37.6961 24.8682C37.6961 26.6745 37.0734 28.3891 35.8258 29.7813C34.1924 31.4502 31.889 32.5156 29.5382 32.7008C26.1315 32.9776 22.7226 33.2106 19.2686 33.2106C15.8123 33.2106 12.4056 33.0712 8.99895 32.7008C6.64595 32.5156 4.34251 31.4502 2.71136 29.7813C1.46375 28.3891 0.838867 26.6745 0.838867 24.8682C0.838867 23.0599 1.22457 21.3931 2.42262 20.0946C4.05593 18.332 4.72821 16.8025 4.72821 14.2076V13.3274C4.72821 9.85224 5.63752 7.57987 7.51001 5.35536C10.294 2.11119 14.7565 0.165527 19.1716 0.165527H19.3655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.75d34fb272001419cfd94d77ba2bebbe.svg";
export { ForwardRef as ReactComponent };